onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='overlapping-package-deactivation']")
    .each((_index, el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        const modalParams = {
          confirmationText: el.dataset.prompt,
          action: el.text,
          url: event.currentTarget.href,
        }

        window.modalCitizen.openModal(
          'overlapping-package-deactivation-modal',
          modalParams
        )
      })
    })
})
